/**
 * Modern Results Hooks
 *
 * Phase 3: Mobile Results Optimization
 */

export {
  useSectionTruncation,
  TRUNCATION_DEFAULTS,
  type UseSectionTruncationOptions,
  type UseSectionTruncationReturn,
} from './useSectionTruncation';

export {
  useCollapsibleState,
  COLLAPSIBLE_DEFAULTS,
  type UseCollapsibleStateOptions,
  type UseCollapsibleStateReturn,
} from './useCollapsibleState';
